<template>
  <div class="procedure-container" @click.stop>
    <h1 class="title page-title">
      <span>{{ t('買取手順') }}</span>
    </h1>
    <div class="step">
      <h3 class="step-title step1">Step1</h3>
      <span>
        <img class="step-img" src="/img/purchase/box.png" alt="箱">
        <p>
          <span>{{ t('弊社へ査定依頼品の発送(発払い)') }}</span>
          <span>{{ t(' & 買取申込フォームの送信') }}</span>
        </p>
      </span>
    </div>
    <div class="step">
      <h3 class="step-title step2">Step2</h3>
      <span>
        <img class="step-img" src="/img/purchase/mail.png" alt="メール">
        <p>
          <span>{{ t('メールにて査定結果の送信') }}</span>
          <span>{{ t('(到着後2営業日以内)') }}</span>
        </p>
      </span>
    </div>
    <div class="step">
      <h3 class="step-title step3">Step3</h3>
      <span>
        <img class="step-img" src="/img/purchase/money.png" alt="お金">
        <p>
          <span>{{ t('お振込') }}</span>
          <span>{{ t('(査定結果へのご同意後2営業日以内)') }}</span>
        </p>
      </span>
    </div>
    <div class="shipping-address">
      <h1 class="shipping-title">{{ t('発送先') }}</h1>
      <p class="address">
        <span class="postal-code">{{ t('〒330-0854') }}</span>
        <span class="address-detail">{{ t('埼玉県さいたま市大宮区桜木町1丁目195‑1 大宮ソラミチKOZ4階') }}</span>
      </p>
    </div>
    <h1 class="warning-title">{{ t('ご留意事項') }}</h1>
    <ul class="warning-list">
      <li>{{ t('1）買取表に掲載しているカードのみ買取可能です。') }}</li>
      <li>{{ t('2）身分証は「運転免許証」「パスポート」「マイナンバー」のいずれかでお願いいたします。') }}</li>
      <li>{{ t('3）100枚までの発送、同名同種のカードは5枚まででお願いいたします。') }}</li>
      <li>{{ t('4）偽物・状態が著しく悪いカード・買取表に掲載のないカードは査定不可となります。') }}</li>
      <li>{{ t('5）返送をご希望の場合は、着払いにてご返送いたします。') }}</li>
      <li>{{ t('6）査定額は、到着時の価格となります。発送時にご確認いただいた価格と異なってしまう場合がございます。') }}</li>
    </ul>
    <div class="button-group">
      <button class="cancel-button" @click="handleCancel">{{ t('キャンセル') }}</button>
      <BuyButton
        :class="{ disabled: !isLoggedIn }"
        class="purchase-btn"
        :text="t('申し込みへ')"
        :isArrow="false"
        :disabled="!isLoggedIn"
        @handleSquareBtnClick="handleApplication"
      />
    </div>
  </div>
</template>

<script>
import BuyButton from '@/components/atoms/BuyButton.vue';
import t from '@/plugins/i18n';

export default {
  name: 'PurchaseProcedure',
  mixins: [t],
  components: {
    BuyButton,
  },
  props: {
    isLoggedIn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleCancel() {
      this.$emit('handleCancel');
    },
    handleApplication() {
      if (this.isLoggedIn) {
        this.$emit('handleApplication');
      } else {
        this.$emit('handleCancel');
        this.$nextTick(() => {
          this.$router.push('/login?redirect=' + encodeURIComponent(this.$route.fullPath));
        });
      }
    },
  },
};

</script>

<style lang="scss" scoped>
.procedure-container {
  overflow: auto;
  text-align: center;
  padding: 20px 20px;
  color: #717071;
  .shipping-title {
    text-align: left;
    font-size: 16px;
  }
  .warning-title {
    text-align: left;
    font-size: 14px;
  }
  .page-title {
    text-align: center;
    span {
      padding: 5px 15px;
      border-radius: 10px;
      background-color: #d35400;
      color: white;
      box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.5);
    }
  }
  p {
      text-align: left;
      font-weight: bold;
      margin: 0;
  }

  .step {
    text-align: left;
    margin: 20px 0 30px 25px;
    display: flex;
    align-items: center;
    @media screen and (max-width: $tabletWidth) {
      margin: 15px 0 25px 15px;
      display: block;
    }
    .step-title {
      font-size: 18px;
      font-weight: bold;
    }
    > span {
      display: flex;
      align-items: center;
    }
    p span {
      @media screen and (max-width: $tabletWidth) {
        display: block;
        font-size: 14px;
      }
    }
    .step-img {
      width: 40px;
      margin: 0 10px;
      @media screen and (max-width: $tabletWidth) {
        margin-left: 20px;
      }
    }
  }
  .shipping-address {
    border: 6px solid rgba(#717071, 0.2);
    border-radius: 25px;
    padding: 10px 15px;
    margin: 20px 0;
  }
  .address {
    text-align: left;
    font-weight: bold;
    .postal-code {
      display: block;
    }
  }
  .warning-list {
    padding-left: 0;
    text-align: left;
    font-weight: bold;
    font-size: 15px;
    li{
      list-style-type: none;
    }
    @media screen and (max-width: $tabletWidth) {
        font-size:13px
      }
  }
  .button-group {
    display: flex;
    margin: 0 auto;
    justify-content: space-around;
    margin-top: 20px;
    left: 50%;
    width: calc(100% - 40px);
    gap: 10px;
    button {
      width: 45%;
      padding: 10px 60px;
      border: none;
      cursor: pointer;
      border-radius: 10px;
      font-size: 16px;
      font-weight: bold;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
      @media screen and (max-width: $tabletWidth) {
        padding: 10px 25px;
      }
    }
    .cancel-button {
      color: #a1a2a2;
    }
  }
}
</style>
